import { ChevronLeft, ChevronRight } from '../../assets/icons';

// `aside` sits right of the page buttons (the total of the invoice lists).
// With it, nothing goes under anything while there is room: the count, the
// buttons and the aside share one line, then the buttons and the aside go
// under the count together, and only then the aside under the buttons.
// Without it, the layout of every other list stays as it was.
const Pagination = ({ currentPage, countPerPage, countTotal, totalPages, setCurrentPage, customText, aside }) => {
  const nbElementStart = countPerPage * (currentPage - 1) + 1;
  const nbElementEnd = Math.min(countPerPage * currentPage, countTotal);

  const getPageNumbers = () => {
    const pages = [];
    for (let p = 1; p <= totalPages; p++) {
      if (p === 1 || p === totalPages || (p >= currentPage - 2 && p <= currentPage + 2)) {
        pages.push(p);
      } else if (p === currentPage - 3 || p === currentPage + 3) {
        pages.push('...');
      }
    }
    return pages;
  };

  const pageButtons = totalPages > 1 && (
    <div className="select-none flex">
      <button
        className="w-9 h-9 rounded-l-lg border border-gray-200 flex justify-center items-center disabled:opacity-50"
        onClick={() => setCurrentPage(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ChevronLeft wh={16} color="#4A5568" />
      </button>
      {getPageNumbers().map((page, idx) =>
        page === '...' ? (
          <span key={`dots-${idx}`} className="w-9 h-9 border border-gray-200 border-l-0 flex justify-center items-center text-gray-400">
            ...
          </span>
        ) : (
          <button
            key={page}
            className={`w-9 h-9 border border-gray-200 border-l-0 flex justify-center items-center ${
              page === currentPage ? 'bg-yellow-500 text-white' : ''
            }`}
            onClick={() => page !== currentPage && setCurrentPage(page)}
          >
            {page}
          </button>
        )
      )}
      <button
        className="w-9 h-9 rounded-r-lg border border-gray-200 border-l-0 flex justify-center items-center disabled:opacity-50"
        onClick={() => setCurrentPage(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ChevronRight wh={16} color="#4A5568" />
      </button>
    </div>
  );

  const layoutClassName = aside
    ? 'flex flex-wrap items-center justify-between gap-x-6 gap-y-3'
    : 'flex flex-col md:flex-row md:justify-between md:items-center gap-3 md:gap-0';

  return (
    <div className={`${layoutClassName} ft-sm min-h-[36px]`}>
      <div>
        {countTotal > 0 && (
          <div className="text-gray-500">
            {customText
              ? customText
              : totalPages > 1
                ? `Affichage de ${nbElementStart}-${nbElementEnd} sur ${countTotal} résultats`
                : `Affichage de ${countTotal} résultats`}
          </div>
        )}
      </div>
      {aside ? (
        <div className="flex flex-wrap items-center gap-3">
          {pageButtons}
          {aside}
        </div>
      ) : (
        pageButtons
      )}
    </div>
  );
};

export default Pagination;
